import { useEffect, useState } from 'react';
import { Card, Button, Typography, Tag, Popover } from 'antd';
import { CheckCircleOutlined, LockOutlined } from '@ant-design/icons';
import ZoomIcon from 'src/assets/zoom.svg';
import { useSelector } from 'react-redux';
import { UpgradeButton } from '../../ambient_solo/components/Payments/UpgradeButton';
import ZoomGuidedTour from './ZoomGuidedTour';

const { Title, Paragraph } = Typography;

const ZoomIntegrationTile = ({ schedulepage = false, isMinimized = false }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [activePopover, setActivePopover] = useState(null);
  const oAuthDevClientId = import.meta.env.VITE_ZOOM_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_ZOOM_REDIRECT_URI;

  const { currentPractitionerEntitlements } = useSelector(
    (state) => state?.practitionerState
  );
  const isAuraPro = currentPractitionerEntitlements?.plans?.some(
    (plan) => plan?.metadata?.type == 'pro'
  );

  const toggleConnection = () => {
    const ZoomAuthCode = localStorage.getItem('ZoomAuthCode');

    if (isConnected) {
      // Remove tokens from localStorage when disconnecting
      localStorage.removeItem('zoomAccessToken');
      localStorage.removeItem('zoomRefreshToken');
      localStorage.removeItem('ZoomAuthCode');

      setIsConnected(false);
    } else if (ZoomAuthCode) {
      setIsConnected(true);
    }
  };

  const handleZoomScope = () => {
    const authUrl = `https://zoom.us/oauth/authorize?response_type=code&client_id=${oAuthDevClientId}&redirect_uri=${encodeURIComponent(redirectUri)}`;

    window.location.href = authUrl;
  };
  const handleShowUpgradeTooltip = (element) => {
    if (!isAuraPro) {
      setActivePopover(element);
    }
  };
  const handleHideUpgradeTooltip = () => {
    setActivePopover(null);
  };

  const handleConnectZoom = () => {
    handleZoomScope();
    toggleConnection();
  };
  // Check localStorage for Zoom tokens on component mount
  useEffect(() => {
    const accessToken = localStorage.getItem('zoomAccessToken');
    const refreshToken = localStorage.getItem('zoomRefreshToken');
    const ZoomAuthCode = localStorage.getItem('ZoomAuthCode');

    if (accessToken && refreshToken && ZoomAuthCode) {
      setIsConnected(true);
    }
  }, []);
  return (
    <div
      className={`flex flex-col ${schedulepage ? '' : 'page-wrapper'} past ${
        isMinimized ? 'page-wrapper--minimized' : ''
      }`}
    >
      <Title level={4} className="mb-5 mr-2">
        Available with your plan
      </Title>

      <div className="grid gap-5 [grid-template-columns:repeat(auto-fill,minmax(280px,1fr))]">
        <Card
          className={`rounded-lg h-full relative ${
            isConnected ? 'bg-green-50' : 'bg-white'
          }`}
          bodyStyle={{ padding: 0 }}
        >
          {isConnected && (
            <Tag
              icon={<CheckCircleOutlined />}
              color="success"
              className="absolute top-3 right-3 border-none bg-transparent px-0 py-0"
            >
              Connected
            </Tag>
          )}

          <div className="p-5 flex flex-col gap-4 w-full">
            <img src={ZoomIcon} height={30} width={30} className="mr-2" />

            <div className="flex flex-col gap-1">
              <Title level={5} className="!text-base">
                Zoom
              </Title>

              <Paragraph className="text-gray-600 ">
                Allow bot to join and start the cloud recording for Zoom
                encounter.
              </Paragraph>
            </div>

            <div>
              <ZoomGuidedTour />

              {isConnected ? (
                <div className="flex justify-end items-center">
                  <Button type="text" danger onClick={toggleConnection}>
                    Disconnect
                  </Button>
                </div>
              ) : (
                <Popover
                  content={
                    <div
                      onMouseEnter={() => handleShowUpgradeTooltip('select')}
                      onMouseLeave={handleHideUpgradeTooltip}
                    >
                      <UpgradeButton
                        text="Upgrade to access this feature"
                        analyticsEvent="Clicked Zoom Integration Accees Button"
                      />
                    </div>
                  }
                  open={!isAuraPro && activePopover === 'select'}
                  trigger="hover"
                  placement="rightTop"
                  mouseLeaveDelay={0.3}
                  overlayInnerStyle={{ padding: '0px' }}
                  align={{
                    offset: [0, 0],
                  }}
                  onOpenChange={(visible) => {
                    if (!visible) {
                      handleHideUpgradeTooltip();
                    }
                  }}
                >
                  <Button
                    type="primary"
                    onClick={
                      !isAuraPro
                        ? () => handleShowUpgradeTooltip('select')
                        : handleConnectZoom
                    }
                    className="mt-2 flex justify-center items-center"
                    icon={!isAuraPro && <LockOutlined />}
                    onMouseEnter={() => handleShowUpgradeTooltip('select')}
                    onMouseLeave={handleHideUpgradeTooltip}
                  >
                    {isAuraPro ? 'Connect Zoom' : 'Upgrade to Pro'}
                  </Button>
                </Popover>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ZoomIntegrationTile;
